import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_placard_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { order_id?: number }): Promise<{ result?: { content?: { OrderLookupCode?: string, AccountName?: string, AddressLine1?: string, AddressLine2?: string, City?: string, State?: string, PostalCode?: string, Country?: string, OwnerReference?: string, LotLookupCode?: string, PackagedAmount?: number, PackagedName?: string, LicensePlateCount?: number, PackingCompletedDate?: string }[] } }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      order_id?: number    }) {
      return false;
    }
}
